// extracted by mini-css-extract-plugin
export default {"container":"EditHeader_container__AYurg","text":"EditHeader_text__4p2s6","edit":"EditHeader_edit__5KIPE"};